export const PREJUDICE_TYPE_LIST = [
  'DEPENSE_SANTE_FUTURES',
  'FRAIS_DIVERS_FUTURS',
  'FRAIS_LOGEMENT_ADAPTE',
  'FRAIS_VEHICULE_ADAPTE',
  'PERTES_GAINS_PROFESSIONNELS_FUTURS',
  'INCIDENCE_PROFESSIONNELLE',
  'ASSISTANCE_PAR_TIERCE_PERSONNE_FUTURE',
  'DEFICIT_FONCTIONNEL_PERMANENT',
  'PREJUDICE_AGREMENT',
  'PREJUDICE_ESTHETIQUE_PERMANENT',
  'PREJUDICE_SEXUEL',
  'PREJUDICE_ETABLISSEMENT',
  'PREJUDICE_PERMANENT_EXCEPTIONNEL',
  'DEPENSE_SANTE_ACTUELLES',
  'FRAIS_DIVERS_ACTUELS',
  'PERTES_GAINS_PROFESSIONNELS_ACTUELS',
  'PREJUDICE_SCOLAIRE_UNIVERSITAIRE_FORMATION',
  'ASSISTANCE_PAR_TIERCE_PERSONNE_ACTUELLE',
  'DEFICIT_FONCTIONNEL_TEMPORAIRE_TOTAL',
  'DEFICIT_FONCTIONNEL_TEMPORAIRE_PARTIEL',
  'SOUFFRANCES_ENDUREES',
  'PREJUDICE_ESTHETIQUE_TEMPORAIRE',
  'PREJUDICE_LIES_PATHOLOGIES_EVOLUTIVES',
  'PREJUDICE_IMPREPARATION_MEDICALE',
  'PREJUDICE_ANXIETE',
  'PREJUDICE_MATERIEL',
  'CALCUL_DES_INTERETS_ET_CAPITALISATION_DES_INTERETS',
  'AUTRES_POSTES_DE_PREJUDICES',
  'PREJUDICE_DANGOISSE_DE_MORT_IMMINENTE',
  'INDEMNITE_PROVISIONNELLE',
  'PERTES_REVENUS_DES_PROCHES',
  'FRAIS_OBSEQUES',
  'PREJUDICE_ACCOMPAGNEMENT_FIN_DE_VIE',
  'FRAIS_DIVERS_DES_PROCHES',
  'PREJUDICE_AFFECTION_OU_MORAL',
  'PREJUDICES_EXTRA_PATRIMONIAUX_EXCEPTIONNELS',
  'PREJUDICE_ANGOISSE_ET_INQUIETUDE',
] as const;
export type PrejudiceType = (typeof PREJUDICE_TYPE_LIST)[number];

export const PREJUDICE_FORM_TYPE_LIST = [
  'VALEUR',
  'CALENDRIER_VALEURS',
  'CALENDRIER_HOSPITALISATION',
  'CALENDRIER_DEPENSE',
  'CALENDRIER_DEPENSE_CAPITALISATION',
  'CALENDRIER_ASSISTANCE',
  'CALENDRIER_ASSISTANCE_CAPITALISATION',
  'PERTE_GAINS_PROFESSIONNELS_ACTUEL',
  'PERTE_GAINS_PROFESSIONNELS_FUTURS',
  'RETRAITE',
  'LISTE_PROJECTION',
  'CALENDRIER_DEFICIT_FONCTIONNEL_TEMPORAIRE_TOTAL',
  'CALENDRIER_DEFICIT_FONCTIONNEL_TEMPORAIRE_PARTIEL',
  'PERTES_REVENUS_PROCHE',
  'VALEUR_VICTIMES_INDIRECTES',
  'MATERIEL',
  'SCOLAIRE',
] as const;
export type PrejudiceFormType = (typeof PREJUDICE_FORM_TYPE_LIST)[number];
